import React from 'react';
import { loadInvoicePreview } from './controler';
import { CheckoutTimeOptions } from './ReservationActions';
import { getQuery } from '../../newReservations/utils';
import { CheckoutGroupOptions, OverlapOptions } from './CheckoutOptions';
import { CheckoutOptionsProps } from './interfaces';
import InlineModal from '@components/modalInline';
import { ReactComponent as Bill } from '../../../assets/custom/icons/bill.svg';
import {
    ReservationEditModel,
    ReservationModel,
    ReservationModelWithModelsIncluded,
    RoomInfoEditModel,
} from '@common/modelDefinition';
// import { showConfirmationModal } from '@components/modal';
import ReservationForm from '../../newReservations';
import { SRCClearRoomCodes } from '@components/SRCClearRoomCodes';

const GroupReservationActions = (props: CheckoutOptionsProps) => {
    const [checkOut, setCheckout] = React.useState<ReservationModelWithModelsIncluded | null>(null);
    const [reservation, setReservation] = React.useState(null as ReservationModel | null);

    const [groupReservations, setGroupReservations] = React.useState<ReservationModelWithModelsIncluded[]>([]);
    //  const [showAll, setShowAll] = React.useState<boolean>(true);
    const showAll = true;

    const {
        history,
        translate,
        groupReservationsArray,
        stayoverOverlap,
        location,
        reservationId,
        groupUuid,
        roomInfoMap,
        invoicePreview,
    } = props;

    const query: any = getQuery(history.location);
    const _reservationId: number = Number(query.reservationId);

    React.useEffect(() => {
        if (showAll) {
            const reservations: ReservationModelWithModelsIncluded[] = [];
            const filteredReservations = _reservationId
                ? groupReservationsArray.filter((r) => r.id !== _reservationId)
                : [];

            groupReservationsArray.forEach((gr: ReservationModelWithModelsIncluded, index: number) => {
                if (_reservationId) {
                    if (gr.id === _reservationId) {
                        reservations.push(gr);
                    }
                } else {
                    reservations.push(gr);
                }
            });

            filteredReservations.forEach((gr: ReservationModelWithModelsIncluded, index: number) => {
                reservations.push(gr);
            });
            setGroupReservations(reservations);
        } else {
            const reservations: ReservationModelWithModelsIncluded[] = [];
            groupReservationsArray.forEach((gr: ReservationModelWithModelsIncluded, index: number) => {
                if (_reservationId) {
                    if (gr.id === _reservationId) {
                        reservations.push(gr);
                    }
                } else {
                    if (index === 0) {
                        reservations.push(gr);
                    }
                }
            });
            setGroupReservations(reservations);
        }
    }, [showAll, groupReservationsArray, _reservationId]);

    if (groupReservationsArray.length === 0) {
        return null;
    }

    // const groupReservations:ReservationModelWithModelsIncluded[]=[]

    const conflictedReservation: ReservationEditModel | null =
        stayoverOverlap.overlapReservations.length > 0 ? stayoverOverlap.overlapReservations[0] : null;

    return (
        <div>
            {reservation ? (
                <ReservationForm
                    history={history}
                    mousePosition={{ x: 0, y: 0 }}
                    selectedRoomsForReservations={[reservation?.roomInfoId]}
                    toggleSelectRoomForReservation={() => setReservation(null)}
                    reservationId={reservation?.id}
                    groupUuid={reservation?.groupUuid}
                />
            ) : null}

            <InlineModal show={checkOut} header={translate('Checkout options')} width="md" setShow={setCheckout}>
                {checkOut ? (
                    <CheckoutTimeOptions
                        setCheckout={setCheckout}
                        reservation={checkOut}
                        reservationId={reservationId}
                        groupUuid={groupUuid}
                        location={location}
                    />
                ) : null}
            </InlineModal>
            <div className="mb-4p">
                <b>{translate('Reservations from the group')}</b>
            </div>
            <div className="" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                {groupReservations.map((r: ReservationModelWithModelsIncluded, index: number) => {
                    const room: RoomInfoEditModel | null = roomInfoMap ? roomInfoMap[r.roomInfoId] : null;
                    const roomName: string = room ? room.name : '';

                    let reservationHolder: string = `${r.Customer?.firstName} ${r.Customer?.lastName} ${r.Company?.name}`;
                    if (r.Company && r.Customer) {
                        reservationHolder = `${r.Customer?.firstName} ${r.Customer?.lastName} ${r.Company?.name}`;
                    } else if (r.Company) {
                        reservationHolder = `${r.Company?.name}`;
                    } else if (r.Customer) {
                        reservationHolder = `${r.Customer?.firstName} ${r.Customer?.lastName} `;
                    }
                    return (
                        <div key={index}>
                            <div
                                onClick={async () => {
                                    await loadInvoicePreview(r.id);
                                }}
                                key={index}
                                className={
                                    invoicePreview && invoicePreview?.invoice?.reservationId === r.id
                                        ? 'invoice-item-selected pointer'
                                        : 'invoice-item pointer'
                                }
                            >
                                <div className="display-flex align-items-center">
                                    <div className="sm-svg">
                                        <Bill />
                                        {/* <input
                                            disabled={false}
                                            checked={
                                                invoicePreview && invoicePreview?.invoice?.reservationId === r.id
                                                    ? true
                                                    : false
                                            }
                                            onChange={() => {}}
                                            className="checkbox-primary"
                                            type="checkbox"
                                        ></input> */}
                                    </div>
                                    <div className="ml-16p">
                                        <div
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setReservation(r);
                                                // history.push(`/reservations/${r.id}/edit`);
                                            }}
                                            className="button-link"
                                            style={{ paddingTop: '0px' }}
                                        >
                                            #{roomName ? roomName : r.roomInfoId}
                                        </div>
                                    </div>
                                    <div className="ml-16p">{reservationHolder}</div>
                                </div>
                                <div className="display-flex align-items-center justify-content-end">
                                    {r.statusEnum !== 4 ? (
                                        <div>
                                            <button
                                                disabled={
                                                    r.statusEnum !== 2 /* ||
                                            (conflictedReservation && conflictedReservation.roomInfoId !== r.roomInfoId)*/
                                                        ? true
                                                        : false
                                                }
                                                className="button-light mr-16p"
                                                onClick={() => {
                                                    setCheckout(r);
                                                }}
                                            >
                                                {translate('Checkout')}
                                            </button>
                                        </div>
                                    ) : r.statusEnum === 4 && room ? (
                                        <div>
                                            <SRCClearRoomCodes roomInfo={room} className={'mr-16p'} />
                                        </div>
                                    ) : (
                                        <div className="pr-4p pl-4p pt-4p pb-4p mr-16p"></div>
                                    )}
                                    <CheckoutGroupOptions {...props} reservation={r} index={index} />
                                </div>
                            </div>
                            {conflictedReservation && conflictedReservation.roomInfoId === r.roomInfoId && (
                                <OverlapOptions {...props} reservation={r} />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GroupReservationActions;
